export function highestContractFirst(a, b) {
  const first = String(a.NumeroContrat ?? "").trim();
  const second = String(b.NumeroContrat ?? "").trim();
  if (!first || !second) return first ? -1 : second ? 1 : 0;
  const firstNumeric = /^\d+$/.test(first);
  const secondNumeric = /^\d+$/.test(second);
  if (firstNumeric !== secondNumeric) return firstNumeric ? -1 : 1;
  return (
    second.localeCompare(first, "fr", { numeric: true }) ||
    String(b.NumeroAvenant ?? "").localeCompare(
      String(a.NumeroAvenant ?? ""),
      "fr",
      { numeric: true },
    )
  );
}
